const message = {
    //Common Button
    "BTN_SEARCH": "ค้นหา",
    "BTN_CLEAR": "ล้างข้อมูล",
    "BTN_ADD": "เพิ่ม",

    "USR_ACTIVE": "ใช้งาน",
    "USR_INACTIVE": "ไม่ใช้งาน",

    //fin page header
    "HDR_SETFEE": "กำหนดการใช้งานอัตราค่าธรรมเนียมการศึกษา",
    //"HDR_SETFEE_YEAR_SEARCH"            :  "กำหนดการใช้งานอัตราค่าธรรมเนียมการศึกษา",
    "HDR_MANAGE_PATTERN_COPEN": "จัดการกำหนดค่าธรรมเนียมการศึกษา",

    //usr-common
    "USR_LOAD_ERROR_DESCRIPTION": "กรุณาลองเปิดหน้านี้ใหม่อีกครั้ง",
    "USR_LOAD_CAMPUS_ERROR": "โหลดข้อมูลวิทยาเขตไม่สำเร็จ",
    "USR_LOAD_FACULTY_ERROR": "โหลดข้อมูลคณะไม่สำเร็จ",
    "USR_LOAD_EDULEVEL_LIST_ERROR": "โหลดข้อมูลระดับการศึกษาไม่สำเร็จ",

    //common
    "COMMON__COLLAPSE_DATA_NOT_FOUND": "ไม่พบข้อมูลรายละเอียดของรายการนี้",
    "COMMON__YES": "ใช่",
    "COMMON__NO": "ไม่",
    "COMMON__SHOW": "แสดง",
    "COMMON__DO_NOT_SHOW": "ไม่แสดง",
    "COMMON__ACCEPT": "เลือกรับ",
    "COMMON__DO_NOT_ACCEPT": "ไม่เลือกรับ",
    "COMMON__RECORD_STATUS": "สถานะการใช้งาน",
    "COMMON__ADD_DETAILS": "เพิ่มรายละเอียด",
    "COMMON__RECORD_STATUS_ACTIVE": "ใช้งาน",
    "COMMON__RECORD_STATUS_INACTIVE": "ไม่ใช้งาน",
    "COMMON__PLEASE_ADD_DETAILS": "กรุณากดเพิ่มรายละเอียด",
    "COMMON__IMPORT_LIST": "Import รายชื่อ",
    "COMMON__CREATED_DATE": "วันที่สร้างรายการ",
    "COMMON__CREATED_BY": "ผู้สร้างรายการ",
    "COMMON__UPDATED_DT": "วันที่แก้ไขล่าสุด",
    "COMMON__EDIT_DATE": "วันที่แก้ไขรายการ",
    "COMMON__UPDATED_BY": "ผู้แก้ไข",
    "COMMON__EDITED_BY": "ผู้แก้ไขรายการล่าสุด",
    "COMMON__CF_DELETE_DATA": "กรุณายืนยัน ต้องการลบข้อมูล",
    "COMMON__OR_NOT": "หรือไม่",
    "COMMON__DELETE_DATA": "ลบข้อมูล",
    "COMMON__ALL_RESULTS": "ผลการค้นหาทั้งหมด",
    "COMMON__ITEMS": "รายการ",
    "COMMON__UPDATED_BY_": "ผู้แก้ไขรายการ",
    "COMMON__CANNOT_BE_PROCRESS": "ขออภัยไม่สามารถดำเนินการได้ในขณะนี้",
    "COMMON__TITLE_ADD_DATA": "เพิ่มข้อมูล",
    "COMMON__CF_ADD_DATA": "กรุณายืนยัน ต้องการเพิ่มข้อมูล",
    "COMMON__TITLE_EDIT_DATA": "ยืนยันการแก้ไข",
    "COMMON__CF_EDIT_DATA": "กรุณายืนยัน ต้องการแก้ไขข้อมูล",
    "COMMON__IMPORT_DATA": "นำเข้าข้อมูล",
    "COMMON__CREATE_IMPORT_DT": "วันที่นำเข้าข้อมูล",
    "COMMON__ACADEMIC_YEAR": "ปีการศึกษา",
    "COMMON__SEMESTER": "ภาคการศึกษา",
    "COMMON__IMPORT_DATA_SUCCESS": "นำเข้าข้อมูลสำเร็จ",
    "COMMON__IMPORT_DATA_UNSUCCESS": "นำเข้าข้อมูลไม่สำเร็จ",
    "COMMON__CF_IMPORT_DATA": "กรุณายืนยัน ต้องการนำเข้าข้อมูล",
    "COMMON__SEARCHING": "กำลังค้นหา..",
    "COMMON__STUDENT_CODE": "รหัสนิสิต",
    "COMMON__CAMPUS": "สถานที่จัดการเรียนการสอน",
    "COMMON__FACULTY": "คณะ",
    "COMMON__DEPARTMENT": "ภาควิชา",
    "COMMON__MAJOR": "สาขาวิชา",
    "COMMON__STUDENT_TYPE": "ประเภทนิสิต",
    "COMMON__START_YEAR": "ภาคการศึกษา / ปีการศึกษาที่เข้า",
    "COMMON__SEARCH_STD": "ค้นหานิสิต",
    "COMMON__SELECT_ALL": "เลือกทั้งหมด",
    "COMMON__EDUCATION_LEVEL": "ระดับการศึกษา",
    "COMMON__IMPORT_SUCCESS_TAB": "นำเข้าสำเร็จ",
    "COMMON__IMPORT_UNSUCCESS_TAB": "นำเข้าไม่สำเร็จ",
    "COMMON__CREATE_SAVE_DT": "วันที่บันทึกข้อมูล",
    "COMMON__CREATE_SAVE_BY": "ผู้บันทึกข้อมูล",
    "COMMON__IMPORT_CHANNEL": "ช่องทางการนำเข้า",
    "COMMON__GOBACK_STEP": "ย้อนกลับ",
    "COMMON__START_DATE": 'วันที่เริ่มต้น',
    "COMMON__END_DATE": 'วันที่สิ้นสุด',
    "COMMON__CLICK_FOR_SELECT": "กรุณาคลิกเพื่อเลือก",
    "COMMON__CONFIRM_DELETE_DATA": "กรุณายืนยันต้องการลบข้อมูล",
    "COMMON__AMOUNT": "จำนวนเงิน",
    "COMMON__CAMPUS_CODE": "รหัสวิทยาเขต",
    "COMMON__CONFIRM_DELETE": "กรุณายืนยันการลบข้อมูล",
    "COMMON__BANK": "ธนาคาร",
    "COMMON__UPLOADING": "กำลังอัปโหลดไฟล์",
    "COMMON__SPECIAL_SUBJECT": "โครงการพิเศษ",
    "COMMON__DETAILS": "รายละเอียด",
    "COMMON__DOWNLOAD_TEMPLATE": "ตัวอย่าง Template",
    "COMMON__EX_TEMPLATE": "Template",
    "COMMON__BACK_TO_SEARCH_PAGE": "กลับหน้าค้นหา",
    "COMMON__IMPORT_BY_EXCEL": "ยืนยันการนำเข้าข้อมูล",
    "COMMON__DELETE_SUCCESS": "ลบข้อมูลสำเร็จ",
    "COMMON__CANT_BE_PRCSS_DUP": "ไม่สามารถทำรายการได้เนื่องจาก",
    "COMMON__STUDENT_LIST_NAME": "รายชื่อนิสิต",
    "COMMON__NUMBER_OF_STUDENT(S)": "จำนวนนิสิต",
    "COMMON__CAMPUS_LOCATION": "สถานที่จัดการเรียนการสอน",
    "COMMON__IMPORT_BY": "ผู้นำเข้าข้อมูล",
    "COMMON__IMPORT_DATE": "วันที่นำเข้าข้อมูล",
    "COMMON__VALIDATING": "กำลังตรวจสอบข้อมูล",
    "COMMON__PLEASE_CONFIRM": "กรุณายืนยัน",
    "COMMON__DELETE_SUCCESSFUL": "ลบข้อมูลเรียบร้อย",
    "COMMON__UPLOAD_FILES": "อัปโหลดไฟล์",
    "COMMON__ADD_SUCCESSFUL": "บันทึกข้อมูลเรียบร้อย",
    "COMMON__EDIT_SUCCESSFUL": "แก้ไขข้อมูลเรียบร้อย",
    "COMMON__RETURN_TO_SEARCH_PAGE": "ระบบจะกลับไปสู่หน้าค้นหา",

    //page masterfee
    "MASTER_FEE__FEE_TITLE": "จัดการ Config การเงิน",
    "MASTER_FEE__FEE_DETAIL_TITLE": "รายละเอียดการจัดการค่าธรรมเนียม",
    "MASTER_FEE__FEE_RATE_TITLE": "กำหนดอัตราค่าธรรมเนียม (Pattern)",
    "MASTER_FEE__FEE_RATE_DETAIL_TITLE": "รายละเอียดอัตราค่าธรรมเนียมการศึกษา",
    "MASTER_FEE__FEE_NAME_TH": "ชื่อค่าธรรมเนียม (ไทย)",
    "MASTER_FEE__FEE_NAME_EN": "ชื่อค่าธรรมเนียม (อังกฤษ)",
    "MASTER_FEE__FEE_NAME_PATTERN_TH": "ชื่อค่าธรรมเนียม Pattern (ไทย)",
    "MASTER_FEE__FEE_NAME_PATTERN_EN": "ชื่อค่าธรรมเนียม Pattern (อังกฤษ)",
    "MASTER_FEE__FEE_TYPE": "ประเภทค่าธรรมเนียม",
    "MASTER_FEE__FEE_DESCRIPTION": "คำอธิบาย",
    "MASTER_FEE__NAME_AND_FEE_CODE": "ชื่อ,รหัสค่าธรรมเนียม",
    "MASTER_FEE__PARENT_CODE": "รหัสหัวข้อ",
    "MASTER_FEE__STATUS": "สถานะรายการ",
    "MASTER_FEE__FEE_CODE": "รหัสค่าธรรมเนียม",
    "MASTER_FEE__DELETE_FEE_MANA_SUC": "ลบข้อมูลการจัดการค่าธรรมเนียมสำเร็จ",
    "MASTER_FEE__FEE_DETAIL_STATUS": "สถานะการใช้งาน",
    "MASTER_FEE__FEE_DETAIL_CREATE_BY": "ผู้สร้าง",
    "MASTER_FEE__FEE_DETAIL_CREATE_DATE": "วันที่สร้าง",
    "MASTER_FEE__FEE_DETAIL_EDIT_DATE": "วันที่แก้ไข",
    "MASTER_FEE__FEE_DETAIL_EDIT_BY": "ผู้แก้ไขล่าสุด",
    "MASTER_FEE__FEE_DETAIL_ADD_FEE_SUC": "เพิ่มข้อมูลการจัดการค่าธรรมเนียมสำเร็จ",

    //page normalFee
    "NORMAL_FEE__TITLE": "ค่าธรรมเนียมทั่วไป/ตั้งต้น",
    "NORMAL_FEE__DETAIL_TITLE": "รายละเอียดค่าธรรมเนียมทั่วไป/ตั้งต้น",
    "NORMAL_FEE__FDC_CONFIRM_DELETE": "กรุณายืนยันลบข้อมูลการจัดการค่าธรรมเนียม",
    "NORMAL_FEE__FDC_DELETE_SUC": "ลบค่าธรรมเนียมสำเร็จ",
    "NORMAL_FEE__FDC_FORMAT_CODE": "รหัสรูปแบบ",
    "NORMAL_FEE__NFD_ADD_FEE_DATA_SUC": "เพิ่มข้อมูลค่าธรรมเนียมสำเร็จ",
    "NORMAL_FEE__NFD_SET_DEBT_BY_FEE": "ค่าธรรมเนียมที่ใช้ในการตั้งหนี้ทั่วไป",
    "NORMAL_FEE__NFD_CATEGORY_HEADING": "หัวข้อหมวดหมู่",
    "NORMAL_FEE__NFD_NOT_CATEGORY_HEADING": "ไม่ใช่หัวข้อหมวดหมู่",
    "NORMAL_FEE__SET_AOLLOCATION": "กำหนดการจัดสรร",
    "NORMAL_FEE__AGENCY_CODE": "รหัสหน่วยงาน",
    "NORMAL_FEE__FEE_RATE_TYPE": "รูปแบบการคิดอัตราค่าธรรมเนียม",
    "NORMAL_FEE__USAGE_TYPE": "รูปแบบการนำไปใช้",
    "NORMAL_FEE__ADJUSTMENT_FORMAT": "รูปแบบการปรับ",
    "NORMAL_FEE__DONT_SHOW_MAX_FINE": "ไม่ระบุค่าสูงสุด",
    "NORMAL_FEE__MAX_FINE": "ค่าปรับสูงสุด",
    "NORMAL_FEE__SET_FINE_START_DATE": "กำหนดวันเริ่มต้นคิดค่าปรับ",
    "NORMAL_FEE__SCHEDULE": "กำหนดการ",

    //page ManageBankAccount
    "MBA__TITLE": "ข้อมูลเลขที่บัญชีธนาคาร",
    "MBA__BANK_ACCOUNT_NAME": "ชื่อบัญชีธนาคาร",
    "MBA__ACCOUNT_NAME": "ชื่อบัญชี",
    "MBA__DELETE_BANK_ACC_NO_SUC": "ลบข้อมูลเลขที่ธนาคารสำเร็จ",
    "MBAD__ADD_BANK_ACC_NO_SUC": "เพิ่มข้อมูลเลขที่บัญชีธนาคารสำเร็จ",
    "MBAD__TITLE": "บันทึกข้อมูลเลขที่บัญชีธนาคาร",
    "MBAD__BILLER_ID": "เลข Biller Id",
    "MBAD__BANK_ACCOUNT_TYPE": "ประเภทบัญชีธนาคาร",

    //page ManageInstallment
    "MSI__TITLE": "จัดการแบ่งงวดชำระเงิน",
    "MSI__DELETED_SUC": "ลบข้อมูลการแบ่งงวดชำระเงินสำเร็จ",
    "MSI__NAME_TH": "ชื่อไทย",
    "MSI__NAME_ENG": "ชื่ออังกฤษ",
    "MSI__INSTALLMENT_AMOUNT": "จำนวนแบ่งงวดชำระ",
    "MSI__INSTALLMENT": "งวด",
    "MSI__ADD_SUCCESS": "เพิ่มข้อมูลการแบ่งงวดชำระเงินสำเร็จ",

    //page RequestWaiver
    "RW__HEADER_TITLE": "ขอผ่อนผัน",
    "RW__SUCCESS": "สำเร็จ",
    "RW__FAILED": "ไม่สำเร็จ",
    "RW__REASON": "สาเหตุการขอผ่อนผัน",
    "RW__ALLOW": "อนุมัติ",
    "RW__CREATE_DATE": "วันเวลาที่สร้างรายการข้อมูล",
    "RW__UPDATE_DATE": "วันที่ปรับสถานะ",
    "RW__CREATER": "ผู้ที่สร้างรายการข้อมูล",
    "RW__UPDATER": "ผู้ที่ปรับสถานะ",
    "RW__STATUS_CASE_3": "นิสิตถูกนำเข้าข้อมูลในปีเทอมนี้แล้ว",
    "RW__STATUS_CASE_4": "นิสิตมียอดค้างชำระมากกว่า 2 เทอม",
    "RW__LENIENT_ACADEMIC_YEAR": "ปีการศึกษาที่ผ่อนผัน",
    "RW__LENIENT_SEMESTER": "ภาคการศึกษาที่ผ่อนผัน",
    "RW__LENIENT_STUDENT": "รายชื่อนิสิตที่ได้รับการผ่อนผัน",
    "RW__IMPORT_LENIENT_STUDENT": "นำเข้าข้อมูลผู้ผ่อนผัน",
    "RW__CHOOSE_YEAR_SEMESTER": "กรุณาเลือกภาคการศึกษาและปีการศึกษาที่ขอผ่อนผัน",
    "RW__STUDENT_NOT_FOUND_DT": "*นิสิตที่สามารถผ่อนผันได้ ต้องมีสถานภาพนิสิตเป็น นิสิตปัจจุบัน, นิสิตใหม่, ลาพักการศึกษา และ ถูกลงโทษทางวินัยเท่านั้น",
    "RW__IMPORT": "นำเข้ารายการขอผ่อนผัน",
    "RW__IMPORT_RW_GROUP": "การขอผ่อนผันรายกลุ่ม/บุคคล",

    //form validation
    "VALIDATION__REQUIRED": "กรุณากรอกข้อมูล",
    "VALIDATION__REQUIRED_IF": "กรุณากรอกข้อมูล",
    "VALIDATION__REQUIRED_IF_VALUE": "กรุณากรอกข้อมูล",
    "VALIDATION__LENGTH_GENERAL": "ข้อมูลไม่ถูกต้อง",

    //page scholarship
    "SCHOLARSHIP__ADD": "เพิ่ม ทุนการศึกษา",
    "SCHOLARSHIP__NAME_TH": "ชื่อทุนการศึกษา ภาษาไทย",
    "SCHOLARSHIP__NAME_EN": "ชื่อทุนการศึกษา ภาษาอังกฤษ",
    "SCHOLARSHIP__TYPE_OF_FUNDING": "ประเภทแหล่งทุน",
    "SCHOLARSHIP__NAME_OF_FUNDING": "ชื่อแหล่งทุน",
    "SCHOLARSHIP__ERP_CODE_FUNDING": "กำหนดการจัดสรร (ERP_CODE)",
    "SCHOLARSHIP__TYPE": "ประเภท",
    "SCHOLARSHIP__CLEMENT": "ทำผ่อนผัน",
    "SCHOLARSHIP__CAN_CHOOSE": "ผู้รับทุนเลือกเองได้",
    "SCHOLARSHIP__IMPRESSION": "แสดงในใบเสร็จรับเงิน",//"การแสดงผล",
    "SCHOLARSHIP__IMPRESSION_OPDC": "การแสดงผลรายงาน กพร.",
    "SCHOLARSHIP__PAYBACK_SCHOLARSHIP": "ทุนที่ต้องใช้คืน",
    "SCHOLARSHIP__ONLY_ONE_SCHOLARSHIP": "รับได้แค่ทุนนี้ทุนเดียว",
    "SCHOLARSHIP__SCHOLARSHIP_DETAILS": "รายละเอียดทุน",
    "SCHOLARSHIP__SCHOLARSHIP_CODE": "รหัสทุนการศึกษา",
    "SCHOLARSHIP__ADD_DETAILS_HEADER": "เพิ่ม รายละเอียดทุนการศึกษา/ส่วนลด",
    "SCHOLARSHIP__AMOUNT_DISCOUNT": "ส่วนลดเป็นจำนวนเงิน",
    "SCHOLARSHIP__PERCENT_DISCOUNT": "ส่วนลดเป็น %",
    "SCHOLARSHIP__TYPE_OF_SCHOLARSHIP": "ประเภทการให้ทุน",
    "SCHOLARSHIP__DETAILS_OF_SCHOLARSHIP": "รายละเอียดของทุน",
    "SCHOLARSHIP__FUNDRAISING": "การให้ทุน",
    "SCHOLARSHIP__LIST_OF_FUNDERS": "Import รายชื่อผู้ได้รับทุน",
    "SCHOLARSHIP__FUNDRAISING_DETAILS": "รายละเอียดการให้ทุน",
    "SCHOLARSHIP__ADD_FUNDRAISING_DETAILS": "เพิ่ม รายละเอียดการให้ทุนการศึกษา",
    "SCHOLARSHIP__DETAIL": "รายละเอียดทุนการศึกษา",
    "SCHOLARSHIP__DELETE_DATA_SUCCESS": "ลบรายละเอียดทุนการศึกษาสำเร็จ",
    "SCHOLARSHIP__EDIT_DETAILS_HEADER": "แก้ไข รายละเอียดทุนการศึกษา/ส่วนลด",
    "SCHOLARSHIP__ADD_DETAIL_SUCCESS": "เพิ่มรายละเอียดทุนการศึกษาสำเร็จ",
    "SCHOLARSHIP__EDIT_DETAIL_SUCCESS": "แก้ไขรายละเอียดทุนการศึกษาสำเร็จ",
    "SCHOLARSHIP__SCHOLARSHIP": "ทุนการศึกษา",
    "SCHOLARSHIP__DELETE_SCHOLARSHIP_SUCCESS": "ลบทุนการศึกษาสำเร็จ",
    "SCHOLARSHIP__CF_SAVE_DATA": "รายละเอียดทุนการศึกษา/ส่วนลด",
    "SCHOLARSHIP__SHOW_STUDENT_LIST": "รายชื่อผู้ได้รับทุน",
    "SCHOLARSHIP__IMPORT_BY_MAJOR": "นำเข้าข้อมูลการให้ทุน",
    "SCHOLARSHIP__SEARCH_STUDENT": "รหัส,ชื่อ ผู้รับทุนการศึกษา/ส่วนลด",
    "SCHOLARSHIP__LIST_STD_FUNDERS": "รายชื่อนิสิตทั้งหมดที่ได้รับทุน",
    "SCHOLARSHIP__STUDENT": "นิสิตรหัส",
    "SCHOLARSHIP__DELETE_STUDENT_SUCCESS": "ลบนิสิตสำเร็จ",
    "SCHOLARSHIP__IMPORT_BY_EXCEL_CF": "โดยไฟล์ Excel",
    "SCHOLARSHIP__IMPORT_BY_MAJOR_CF": "รายบุคคล/กลุ่ม",
    "SCHOLARSHIP__ADD_BY_MAJOR": "เพิ่มข้อมูลการให้ทุนรายกลุ่ม/บุคคล สำเร็จ",
    "SCHOLARSHIP__IMPORT_BY_MAJOR_PERSON": "การให้ทุนรายกลุ่ม/บุคคล",
    "SCHOLARSHIP__TITLE_NAME": "ชื่อทุนการศึกษา",
    "SCHOLARSHIP__SEMESTER": "ภาคการศึกษาที่ได้รับทุน",
    "SCHOLARSHIP__ACADEMIC_YEAR": "ปีการศึกษาที่ได้รับทุน",
    "SCHOLARSHIP__STD_FUNDERS_CF": "รายชื่อนิสิตที่ได้รับทุน",
    "SCHOLARSHIP__STUDENT_NOT_FOUND_CASE_2": "ไม่พบข้อมูลนิสิต หรือนิสิตไม่ตรงเงื่อนไขการรับทุน*",
    "SCHOLARSHIP__STUDENT_NOT_FOUND_CASE_3": "นิสิตได้รับทุนการศึกษาในภาคการศึกษานี้แล้ว",
    "SCHOLARSHIP__STUDENT_NOT_FOUND_CASE_4": "ไม่สามารถนำเข้านิสิตได้เนื่องจากมีการนำเข้าข้อมูลซ้ำ",
    "SCHOLARSHIP__STUDENT_NOT_FOUND_DT": "*นิสิตที่สามารถรับทุนได้ ต้องมีสถานภาพนิสิตเป็น นิสิตปัจจุบัน, นิสิตใหม่, ลาพักการศึกษา และ ถูกลงโทษทางวินัยเท่านั้น",
    "SCHOLARSHIP__TAB_STD_TYPE_DATE": "กำหนดช่วงเวลาในการรับทุน",
    "SCHOLARSHIP__SCHOLARSHIP_PERIOD": "ช่วงเวลาในการรับทุน",
    "SCHOLARSHIP__SCHOLARSHIP_PERIOD_DELETED": "ลบช่วงเวลาในการรับทุนสำเร็จ",
    "SCHOLARSHIP__SCHOLARSHIP_PERIOD_ADD": "เพิ่มช่วงเวลาในการรับทุนสำเร็จ",
    "SCHOLARSHIP__NAME": "ชื่อทุน/ส่วนลด",
    "SCHOLARSHIP__NO": "ลำดับที่",
    "SCHOLARSHIP__TYPE_SPORT": "หมวดหมู่ทุน",
    "SCHOLARSHIP__CAN_WITHDRAW": "เบิกได้",
    "SCHOLARSHIP__CAN_NOT_WITHDRAW": "เบิกไม่ได้",
    "SCHOLARSHIP__WITHDRAW_STATUS": "ตรวจสอบสถานะการเบิก",

    //page setdebt
    "SETDEBT__CREATE_DEBT_BUTTON": "สร้างหนี้ใหม่",
    "SETDEBT__PLEASE_SEARCH_STUDENT": "กรุณาค้นหานิสิตในช่องด้านบน",
    "SETDEBT__CREATE_DEBT_IMPORT_BUTTON": "สร้างหนี้ผ่านการนำเข้าข้อมูล",

    //page DogSinger
    "DOCSIGNER__TITLE": "ผู้ลงนามในเอกสาร",
    "DOCSIGNER__ADD_BT": "เพิ่มผู้ลงนามในเอกสาร",
    "DOCSIGNER__POSITION": "ตำแหน่ง",
    "DOCSIGNER__POSITION_TH": "ตำแหน่ง (ไทย)",
    "DOCSIGNER__POSITION_EN": "ตำแหน่ง (Eng)",
    "DOCSIGNER__NAME_PREFIX": "คำนำหน้าชื่อ",
    "DOCSIGNER__NAME_Th": "ชื่อ (ไทย)",
    "DOCSIGNER__NAME_En": "ชื่อ (Eng)",
    "DOCSIGNER__MIDNAME_TH": "ชื่อกลาง (ไทย)",
    "DOCSIGNER__MIDNAME_EN": "ชื่อกลาง (Eng)",
    "DOCSIGNER__LASTNAME_Th": "นามสกุล (ไทย)",
    "DOCSIGNER__LASTNAME_En": "นามสกุล (Eng)",
    "DOCSIGNER__DOC_TYPE": "ประเภทเอกสาร",
    "DOCSIGNER__SIGNER_TYPE": "ประเภทผู้ลงนามที่สามารถลงนามได้",
    "DOCSIGNER__DIR_OF_TREASUARY": "ผู้อำนวยการกองคลัง",
    "DOCSIGNER__FINANCIAL_OFFICER": "เจ้าหน้าที่การเงิน",
    "DOCSIGNER__SIGNATURE_TH": "ลายเซ็นภาษาไทย",
    "DOCSIGNER__SIGNATURE_EN": "ลายเซ็นภาษาอังกฤษ",
    "DOCSIGNER__UPLOAD_SUGGEST": "คำแนะนำในการแนบไฟล์",
    "DOCSIGNER__UPLOAD_SUGGEST_DETAIL": "รูปแบบไฟล์แนบ .jpg, .png เท่านั้น และขนาดรูปภาพไม่เกิน 200 x 50 pixel",
    "DOCSIGNER__MAIN_SIGNER": "ผู้ลงนามหลัก",
    "DOCSIGNER__REP_SIGNER": "ผู้ลงนามแทน",
    "DOCSIGNER__FILE_TOO_BIG": "ไฟล์รูปมีขนาดใหญ่เกินไป",
    "DOCSIGNER__FILE_ONLY_IMG": "จะต้องเป็นไฟล์รูปภาพเท่านั้น",
    "DOCSIGNER__FILE_TOO_WIDTH": "ความกว้างและความยาวของรูปจะต้องไม่เกิน 200*50 pixel",

    //page refund
    "REFUND__TITLE": "คืนเงิน",
    "REFUND__CREATE_REFUND": "สร้างรายการคืนเงิน",
    "REFUND__LIST_NAME": "ชื่อรายการ",
    "REFUND__REFUND_TYPE": "ประเภทการได้รับเงินคืน",
    "REFUND__MAX_AMT": "จำนวนวงเงินคืนสูงสุด",
    "REFUND__REFUND_DATE": "ช่วงเวลาที่เกิดรายการคืนเงิน",
    "REFUND__TO": "ถึง",

    //page payment
    "PAYMENT__UNPAID_LIST": "รายการค้างชำระ",
    "PAYMENT__PAID_LIST": "รายการชำระสำเร็จ",
    "PAYMENT__SCHOLARSHIP_LIST": "รายการทุนการศึกษา/ส่วนลด",
    "PAYMENT__CURRENT_STUDENT_STATUS": "สถานภาพปัจจุบันของนิสิต",
    "PAYMENT__WITHDRAWABLE_STATUS": "สิทธิในการเบิกค่าการศึกษาบุตร",
    "PAYMENT__STUDENT_NAME": "ชื่อ, รหัสนิสิต",
    "PAYMENT__FACT_NAME": "การชำระเงินของนิสิต",
    "PAYMENT__INSTALLMENT_TYPE": "ประเภทการชำระเงิน",
    "PAYMENT__DEBT_AMOUNT": "จำนวนเงินตั้งหนี้",
    "PAYMENT__NET_AMOUNT": "จำนวนเงินที่ต้องชำระ",
    "PAYMENT__REFERENCE_NUMBER": "หมายเลขอ้างอิง",
    "PAYMENT__PAY_VIA_BANK": "ชำระเงินผ่านธนาคาร",
    "PAYMENT__BANK_ACCOUNT": "เลขที่บัญชี",
    "PAYMENT__WITHDRAW_AMOUNT": "ยอดจากบันชีรอถอนคืน",
    "PAYMENT__BY_CASH": "ชำระด้วยเงินสด",
    "PAYMENT__PRINT_RECEIPT_TYPE": "เลือกประเภทการพิมพ์ใบเสร็จ",
    "PAYMENT__CAUSE_CANCEL": "สาเหตุการยกเลิก",
    "PAYMENT__FEE_DETAIL": "รายการค่าธรรมเนียม",
    "PAYMENT__STUDENT_DETAIL": "รายละเอียดนิสิต",
    "PAYMENT__FISCAL_YEAR": "ปีงบประมาณ",
    "PAYMENT__NUMBER_PRINT": "จำนวนครั้งที่พิมพ์ไปแล้ว",
    "PAYMENT__CREDIT": "ค่าหน่วยกิต",
    "PAYMENT__FACULTY": "ค่าคณะ",
    "PAYMENT__FEE_UNIVERSITY": "ค่าบำรุงมหาวิทยาลัย (ภาคพิเศษ)",
    "PAYMENT__TIME_STUDENT": "เวลาในการจัดการเรียนการสอน",
    "PAYMENT__CANCEL_RECEIPT": "ยกเลิกใบเสร็จ",
    "PAYMENT__CANCEL_INVOICE": "ยกเลิกใบแจ้งหนี้",
    "PAYMENT__CANCEL_RECEIPT_LIST": "ยกเลิกรายการใบเสร็จ",
    "PAYMENT__CANCEL_INVOICE_LIST": "ยกเลิกรายการใบแจ้งหนี้",
    "PAYMENT__CONFIRM_CANCEL_RECEIPT": "ต้องการยกเลิกรายการใบเสร็จหรือไม่",
    "PAYMENT__CONFIRM_CANCEL_INVOICE": "ต้องการยกเลิกรายการใบแจ้งหนี้หรือไม่",
    "PAYMENT__RECEIPT_ID": "เลขที่ใบเสร็จ",
    "PAYMENT__INVOICE_ID": "เลขที่ใบแจ้งหนี้",
    "PAYMENT__DISCOUNT_AMT": "ส่วนลด",
    "PAYMENT__IMPORT_DATA_SAVED": "บันทึกข้อมูลนำเข้าสำเร็จ",
    "PAYMENT__DOWNLOAD_ERR1": "ไม่สามารถ Download ได้เนื่องจาก ไม่พบเลขที่ใบแจ้งหนี้",
    "PAYMENT__DOWNLOAD_ERR2": "ไม่สามารถ Download ได้เนื่องจาก ไม่พบเลขที่ใบเสร็จ",

    //page erp
    "ERP__CODE": "รหัสมิติหน่วยงาน",
    "ERP__CODE_NAME": "ชื่อหน่วยงาน",
    "ERP__CODE_NAME_TH": "ชื่อหน่วยงาน (ไทย)",
    "ERP__CODE_NAME_EN": "ชื่อหน่วยงาน (อังกฤษ)",
    "ERP__DETAIL": "ข้อมูลมิติหน่วยงาน",
    "ERP__PROJECT_CODE": "รหัสโครงการ",
    "ERP__ADD_SUCCESS": "เพิ่มข้อมูลมิติหน่วยงานสำเร็จ",
    "ERP__Force_Stucture": "ระบุตามโครงสร้าง",
    "ERP__SAVE_DUPLICATED_TITLE": "ไม่สามารถสร้าง Erp ใหม่ได้",
    "ERP__SAVE_DUPLICATED_DESCRIPTION": "เนื่องจากข้อมูลที่กรอกเข้ามา ซ้ำกับ Erp ตัวอื่นแล้ว กรุณาลองเปลี่ยนข้อมูลบางอย่างแล้วลองบันทึกอีกครั้ง",

    //page fine
    "FINE__PAGE_TITLE": "ค่าปรับหน่วยงานภายนอก",
    "FINE__TITLE_IMPORT": "นำเข้ารายชื่อค่าปรับจากหน่วยงานภายนอก",
    "FINE__ORG": "หน่วยงาน",
    "FINE__STUDENT_NOT_FOUND": "ไม่พบข้อมูลนิสิต",
    "FINE__STUDENT_DUP": "นิสิตถูกนำเข้าข้อมูลของหน่วยงานในปีเทอมนี้แล้ว",
    "FINE__SEARCH_STUDENT": "รหัส,ชื่อ รายชื่อนิสิตนำเข้าค่าปรับจากหน่วยงานภายนอก",
    "FINE__FINE": "ค่าปรับ",
    "FINE__RETURN_BOOK": "ค้างส่งหนังสือ",
    "FINE__RETURN_SPORT_EQUIP": "ค้างส่งอุปกรณ์กีฬา",
    "FINE__STATUS": "สถานะ",
    "FINE__CAUTION": "หมายเหตุ:",

    //page specialSubject
    "SPECIALSUBJECT__FEE_TITLE_SPECIAL": "การจัดการค่าธรรมเนียมโครงการพิเศษ",
    "SPECIALSUBJECT__FEE_NAME": "ชื่อค่าธรรมเนียม",
    "SPECIALSUBJECT__SEMESTER_YEAR": "ภาคการศึกษา / ปีการศึกษา",
    "SPECIALSUBJECT__RESULT": "ผลลัพธ์",
    "SPECIALSUBJECT__DELETE_SUCCESS": "ลบรายการค่าธรรมเนียมสำเร็จ",
    "SPECIALSUBJECT__ADD_FEE_TITLE_SPECIAL": "เพิ่ม การจัดการค่าธรรมเนียมโครงการพิเศษ",
    "SPECIALSUBJECT__TYPE_TRANSACTION": "ประเภทรายการ",
    "SPECIALSUBJECT__SUBJECT_CODE_NAME": "รหัส/ชื่อวิชา",
    "SPECIALSUBJECT__SUBJECT_NAME": "ชื่อวิชา",
    "SPECIALSUBJECT__SUBJECTS": "ชุดรายวิชา",
    "SPECIALSUBJECT__PAY_UNIVERSITY": "อัตราค่าบำรุงมหาวิทยาลัย",
    "SPECIALSUBJECT__PAY_FACULTY": "อัตราค่าคณะ",
    "SPECIALSUBJECT__PAY_CREDIT": "อัตราค่าหน่วยกิต",
    "SPECIALSUBJECT__LECTURE_PAY_CREDIT": "ราคาหน่วยกิตบรรยาย",
    "SPECIALSUBJECT__LAB_PAY_CREDIT": "ราคาหน่วยกิตปฏิบัติ",
    "SPECIALSUBJECT__SET_RATE": "กำหนดอัตรา",
    "SPECIALSUBJECT__TOTAL_UNIVERSITY_RATE": "ผลรวมอัตราค่าบำรุงมหาวิทยาลัย",
    "SPECIALSUBJECT__TOTAL_FACULTY_RATE": "ผลรวมอัตราค่าคณะ",
    "SPECIALSUBJECT__TOTAL_CREDIT_RATE": "ผลรวมอัตราค่าหน่วยกิต",
    "SPECIALSUBJECT__SPECIAL_FEE_SUCCESS": "เพิ่ม ค่าธรรมเนียมโครงการพิเศษสำเร็จ",
    "SPECIALSUBJECT__ADD_SUBJECTS_SUCCESS": "เพิ่ม รายการวิชาสำเร็จ",
    "SPECIALSUBJECT__ADD_SET_SUCCESS": "เพิ่ม รายการชุดวิชาสำเร็จ",
    "SPECIALSUBJECT__DELETE_SUBJECTS_SUCCESS": "ลบรายวิชาสำเร็จ",
    "SPECIALSUBJECT__DELETE_SET_SUCCESS": "ลบรายการชุดวิชาสำเร็จ",

    //page SubjectBundle
    "SUBJECTSBUNDLE__SUBJECTS_TYPE": "ชุดรายวิชา",
    "SUBJECTSBUNDLE__NAME_AND_CODE": "ชื่อ,รหัส ชุดรายวิชา",
    "SUBJECTSBUNDLE__SUBJECTS_NAME_TH": "ชื่อชุดรายวิชา (ไทย)",
    "SUBJECTSBUNDLE__SUBJECTS_NAME_EN": "ชื่อชุดรายวิชา (อังกฤษ)",
    "SUBJECTSBUNDLE__ADD_SUBJECTS_SUCCESS": "เพิ่มประเภทชุดรายวิชาสำเร็จ",
    "SUBJECTSBUNDLE__ADD_DATA_COURSE_SUCCESS": "เพิ่มข้อมูลหลักสูตรสำเร็จ",
    "SUBJECTSBUNDLE__DELETE_COURSE_SUCCESS": "ลบหลักสูตรสำเร็จ",

    "BTN_DOWNLOAD": "ดาวน์โหลด",

    "SCHOLARSHIP__CONFIRM_FUND_IMPORT": "นำเข้าเงินจากหน่วยงาน",
    "SCHOLARSHIP__CONFIRM_FUND_IMPORT_UPLOAD": "Import รายการนำเข้าเงินจากหน่วยงาน",

    "REFUND__EDIT_REFUND": "แก้ไขการคืนเงิน",

    "PAYMENT__BY_PROJECT" : "ผ่านโครงการ",

    "PAYMENT__CREDITBALANCE_TYPE": "ชนิดของ Creditbalance",
    "PAYMENT__CREDITBALANCE_TYPE_OVERIDE": "ชนิดของการชำระที่จะแสดง",
    "PAYMENT__BY_CREDITBALANCE": "ชำระด้วย Creditbalance",

    "ERP__Special_Project_Flag" : "เป็นโครงการพิเศษ",


    "SPECIALSUBJECT__BOOK_COST": "ค่าหนังสือรายวิชาแบบเหมา(บาท)",
    "SPECIALSUBJECT__ADD_STUDENT_TO_SS": "เพิ่มนิสิตเข้าหลักสูตรพิเศษ",
    "SPECIALSUBJECT__BY_UNIT": "คิดตามหน่วยกิต",
    "SPECIALSUBJECT__BY_SUBJECT": "เหมารายวิชา",


    //page E-Student Loan
    "UNIVERSITY_LOAN__FUND_TYPE": "ประเภทกองทุน",

    //Message Error ps. NFMSG = New FIN Message
    "NFMSG__SAVE_DATA_ERROR": "เกิดข้อผิดพลาดระหว่างบันทึกข้อมูล",
    "NFMSG__LOAD_DATA_ERROR": "เกิดข้อผิดพลาดระหว่างโหลดข้อมูล", //ใช้สำหรับ else error ตัวสุดท้าย
    "NFMSG__PLZ_TRY_AGAIN": "กรุณาลองใหม่อีกครั้ง",
    "NFMSG__CANNOT_BE_SAVE": "ไม่สามารถบันทึกรายการได้",
    "NFMSG__CAUSE": "เนื่องจาก",
    "NFMSG__DUP_SCHOLARSHIP_SEQ": "มีลำดับที่ซ้ำในระบบ",
    "NFMSG__ALREADY_HAVE_IN_CAMPUS": "มีการบันทึกรายละเอียดการให้ทุนการศึกษาของวิทยาเขต ภาคการศึกษา และปีการศึกษานี้ในระบบแล้ว",

    //payment detail
    "FNSTD__PAYMENT_DATE": "วันที่ชำระเงิน",
    "FNSTD__RECEIPT_DETAILS": "รายละเอียดใบเสร็จ",
    "FNSTD__PRINT_RECEIPT": "พิมพ์ใบเสร็จ",
    "FNSTD__PRINT_INVOICE": "พิมพ์ใบแจ้งหนี้",
    "FNSTD__CHOOSE_RECEIPT": "กรุณาเลือกรูปแบบใบเสร็จ",
    "FNSTD__MASTER_RECEIPT": "ใบเสร็จต้นฉบับ",
    "FNSTD__COPY_RECEIPT": "สำเนาใบเสร็จ",

    //allocation
    "ALLO__CONFIG_TITLE": "กำหนดรอบการจัดสรร",
    "ALLO__ALLO_NAME_TH": "ชื่อการจัดสรร",
    "ALLO__ALLO_NAME_EN": "ชื่อการจัดสรรภาษาอังกฤษ",
    "ALLO__CONFIGURE_PAGE_TITLE": "กำหนดรอบการจัดสรร",

    "USR_LOAD_CONFIG_ERROR": "โหลดข้อมูลการตั้งค่าไม่สำเร็จ",

    "COMMON__NUMBER_OF_STUDENTS": "จำนวนนิสิต",

    "ALERT__FAILED_TO_SAVE_DATA": "บันทึกข้อมูลไม่สำเร็จ",
    "ALERT__FAILED_COMMON_DESC" : "กรุณาลองใหม่อีกครั้ง หากยังไม่สำเร็จกรุณาติดต่อเจ้าหน้าที่",
    "CLS_EXAM__DATA_NOT_FOUND" : "ไม่พบข้อมูลวิชา กรุณาค้นหาผ่านช่องการค้นหาด้านบน",

    "LNF_NO_STUDENTS" : "ไม่พบข้อมูลนิสิต",
    "EXAM_EXAMINER_LABEL" : "ชื่อผู้คุมสอบ",
    "EXAM_STUDENT_REGISTER" : "Registered students",
    "EXAM_STUDENT_COUNT" : "จำนวนนิสิตที่จัดห้องสอบแล้ว",

    "COMMON__DATE": "วันที่",
    "COMMON__START_TIME": "เวลาเริ่มต้น",
    "COMMON__END_TIME": "เวลาสิ้นสุด",
}

export default message;
